import { Navigate, useRoutes } from "react-router-dom";
import { dashboardRoutes } from "./dashboardRoutes";

import Home from "../pages/Home";

export default function Router() {
  return useRoutes([
    {
      path: "/",
      element: <Home />,
    },
    ...dashboardRoutes,
    // No match 404
    { path: "*", element: <Navigate to="/404" replace /> },
  ]);
}
